import React from "react";
import "../App.css";

const Menu = ({ setLineColor, setLineWidth, setLineOpacity }) => {

return (
	<div className="Menu">
        <div>
            <label>Pen Color </label>
            <br /><br />
            <input
                type="color" value="#e66465"
                onChange={(e) => {
                setLineColor(e.target.value);
                }}
	        /> 
        </div><br />

        <div>
            <input
                type="color" value="#f6b73c"
                onChange={(e) => {
                setLineColor(e.target.value);
                }}
	        /> 
        </div><br /><br />
        <div>
            <label>Lile Width </label>
            <br /><br /><br />
            <input
                type="range"
                min="3"
                max="20"
                onChange={(e) => {
                setLineWidth(e.target.value);
                }}
            />
        </div><br /><br />
        <div>
            <label>Line Opacity</label>
            <br /><br />
            <input
                type="range"
                min="1"
                max="100"
                onChange={(e) => {
                setLineOpacity(e.target.value / 100);
            }}
	        />
        </div>
        
	
	</div>
);
};

export default Menu;
